import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import EvaluationWithChart from './CardComponents/EvaluationWithChart';
import EvaluationWithText from './CardComponents/EvaluationWithText';
import EvaluateDialog from './EvaluationDialog';
import TextAnswer from './CardComponents/TextAnswer';
import { CRITERIA_TYPES } from '../../utils/const';

const CardSelectorAndEvaluationDialogContainer = ({
  rate, rateable, doughnutChartColor, idOfCurrentUser, onSubmitSuccess
}) => {
  const [ dialogOpen, setDialogOpen ] = useState(false);
  const isOnlyText = rate.criteria.criteria_type === CRITERIA_TYPES.ONLY_TEXT;

  const selectCardToDisplay = valueToDisplay => (
    (valueToDisplay || valueToDisplay === 0) ?
      <EvaluationWithChart
        nameToDisplay = { rate.criteria.criteria_name.hu }
        valueToDisplay = { valueToDisplay }
        rateable = { rateable }
        color = { doughnutChartColor }
        handleDialogeOpen={ () => setDialogOpen(true) }
      /> :
      <EvaluationWithText
        nameToDisplay = { rate.criteria.criteria_name.hu }
        rateable = { rateable }
        handleDialogeOpen={ () => setDialogOpen(true) }
        isOnlyText ={ isOnlyText }
        textAnswer ={ rate.text }
      />
  );

  return (
    <>
      <Grid container direction = { 'row' }>
        { selectCardToDisplay(rate.value) }

        { rate.text && <TextAnswer
          textAnswerTodisplay = { rate.text }
        /> }
      </Grid>

      <EvaluateDialog
        open={ dialogOpen }
        handleClose={ () => setDialogOpen(false) }
        nameOfCriteria={ rate.criteria.criteria_name.hu }
        rateOfCriteria={ rate }
        employeeId={ idOfCurrentUser }
        isOnlyText={ isOnlyText }
        onSubmitSuccess={ onSubmitSuccess }
      />
    </>
  );
};

export default CardSelectorAndEvaluationDialogContainer;
